import _extends from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Slider from 'react-slick';
import { ArrowIcon } from "../_global/Icons";
import Link from 'next/link';
import isExternalLink from "../../utils/isExternalLink";
import { heroSlickSettings } from "./homeUtils";
import { HeroPrevArrowContainer, HeroNextArrowContainer, Banner, BannerWrapper, SliderPlaceholder } from "./style";
var Hero = /*#__PURE__*/function (_Component) {
  function Hero(props) {
    var _this;
    _classCallCheck(this, Hero);
    _this = _callSuper(this, Hero, [props]);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    return _this;
  }
  _inherits(Hero, _Component);
  return _createClass(Hero, [{
    key: "next",
    value: function next() {
      this.slider.slickNext();
    }
  }, {
    key: "previous",
    value: function previous() {
      this.slider.slickPrev();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var heroes = this.props.heroes;
      var useExternalLink = false;
      var href = function href(hero) {
        var linkUrl = hero.linkUrl || '';
        if (hero.notMerchant) {
          useExternalLink = isExternalLink(linkUrl);
          return linkUrl;
        }
        return "/merchant?slug=".concat(linkUrl.replace('?', '&').replace(/\+/g, '%2B'));
      };
      var ArrowRight = function ArrowRight() {
        return __jsx(HeroNextArrowContainer, {
          onClick: _this2.next
        }, __jsx(ArrowIcon, {
          direction: "right"
        }));
      };
      var ArrowLeft = function ArrowLeft() {
        return __jsx(HeroPrevArrowContainer, {
          onClick: _this2.previous
        }, __jsx(ArrowIcon, {
          direction: "left"
        }));
      };
      var customSlickSetting = _objectSpread(_objectSpread({}, heroSlickSettings), {}, {
        arrows: true,
        prevArrow: __jsx(ArrowLeft, null),
        nextArrow: __jsx(ArrowRight, null)
      });
      return __jsx(BannerWrapper, {
        paddingTop: "1rem"
      }, heroes.length > 0 ? __jsx(Slider, _extends({}, customSlickSetting, {
        className: "js-hero-carousel",
        ref: function ref(arg) {
          _this2.slider = arg;
        }
      }), heroes.map(function (hero, index) {
        hero && hero.hasOwnProperty('linkUrl');
        {
          var heroUrl = href(hero);
          return useExternalLink ? __jsx("a", {
            href: heroUrl,
            target: "_blank",
            rel: "noopener noreferrer"
          }, __jsx(Banner, {
            mobileImage: hero.mobileImage,
            desktopImage: hero.desktopImage,
            name: index
          })) : __jsx(Link, {
            href: heroUrl,
            as: "/".concat(hero.linkUrl),
            key: index
          }, __jsx("a", {
            title: "Link to more information"
          }, __jsx(Banner, {
            mobileImage: hero.mobileImage,
            desktopImage: hero.desktopImage,
            name: index
          })));
        }
      })) : __jsx(SliderPlaceholder, null));
    }
  }]);
}(Component);
Hero.defaultProps = {
  heroes: []
};
export default Hero;